module.exports = __webpack_public_path__ + "static/assets/394d8584e39b6b9e4e88bc493904e851.png";